export const enum SystemUserRole {
  Administrator,
  Manager,
  User,
}

export const enum UserStatus {
  Invitation = -1,
  Inactive,
  Active,
  All,
}

export interface UserFilter {
  label: string
  status: UserStatus
  count: number
  scope: UserScope[]
}

export interface UserFull extends BaseUser {
  status: UserStatus
  language: string
  company?: string
  script?: string
  roles?: Record<string, UserRole>
  contacts?: UserContact
  carrotquest_key?: string
}

export interface UserInvitation {
  email: string
  role: UserRole
}

export interface CompanyUser {
  id: string
  role: UserRole
  email?: string
  fname?: string
  lname?: string
  avatar?: string
  active?: boolean
}

export interface UserCredentials {
  old: string
  new: string
}

export interface UserRole {
  readonly id: number
  name: string
  scope: string[]
  system?: boolean
}

export interface UserContact {
  fname: string
  lname: string
  phone: string | null
  country: string | null
  city: string | null
  region: string | null
  postcode: string | null
  address: string | null
}

export interface BaseUser {
  readonly id: number
  email: string
}

export interface CompanyRole {
  id: string
  name: string
  scope: UserScope[]
  system: boolean
}

export interface ReqSavedFilter {
  section: string
  title: string
  query: string
}

export interface ResSavedFilter extends ReqSavedFilter {
  id: string
}

export interface AssignUserRoleRequest {
  role: number
  user: string
}

export interface CancelInvitationRequest {
  email: string
}

export interface InvitationRequest {
  email: string
  role: number
}

export enum UserScope {
  Core = 'core',
  CoreInfo = 'core.info',
  Roles = 'roles',
  Users = 'users',
  Scripts = 'scripts',
  ScriptsDelete = 'scripts.delete',
  ScriptsPublish = 'scripts.publish',
  ScriptsEdit = 'scripts.edit',
  ScriptsUse = 'scripts.use',
  ScriptsView = 'scripts.view',
  Stats = 'stats',
  Knowledge = 'knowledge',
  KnowledgeView = 'knowledge.view',
  KnowledgeEdit = 'knowledge.edit',
  SystemCompany = 'systemcompany',
  Recordings = 'scripts.recordings',
  Finance = 'finance'
}

export const scriptScopeSubtypes: UserScope[] = [
  UserScope.ScriptsDelete,
  UserScope.ScriptsPublish,
  UserScope.ScriptsEdit,
  UserScope.ScriptsUse,
  UserScope.ScriptsView,
  UserScope.Recordings
]

export const knowledgeScopeSubtypes: UserScope[] = [
  UserScope.KnowledgeEdit,
  UserScope.KnowledgeView,
]
